"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MobileNewbuildingCard = require("./MobileNewbuildingCard");
Object.keys(_MobileNewbuildingCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MobileNewbuildingCard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MobileNewbuildingCard[key];
    }
  });
});